import { getDataAsync, postDataAsync, putDataAsync, deleteDataAsync } from "./PortalApi";
import UserRequest from "interfaces/request/UserRequest";
import UserResponse from "interfaces/response/UserResponse";
import StripeCustomerResponse from "interfaces/response/StripeCustomerResponse";
import { DataGridPageSize } from "../../src/shared/constants/GridConstantValues";

export const getAllUsersAsync = async(currentPage = 1, pageSize = DataGridPageSize) => {
  const routeUrl = `Users?Page=${currentPage}&Size=${pageSize}`;
  const response = await getDataAsync<any>(routeUrl);

  return response;
};

export const createPortalUserAsync = async(data: UserRequest) => {
  const routeUrl = `Users`;

  return await postDataAsync<UserRequest, UserResponse>(routeUrl, data);
};

export const updatePortalUserAsync = async (userId: number, data: UserRequest) => {
  const routeUrl = `Admin/Users/${userId}`;

  return await putDataAsync<UserRequest, UserResponse>(routeUrl, data);;
};

export const deleteUserAsync = async (userId: number) => {
  const routeUrl = `Users/${userId}`;
  
  return await deleteDataAsync<UserResponse>(routeUrl);
};

export const createStripeCustomerAsync = async(userId: number) => {
  const routeUrl = `Users/${userId}/StripeCustomer`;
  const response = await postDataAsync<any, StripeCustomerResponse>(routeUrl, null);

  return response;
};